<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- B200系共通部品_Steps -->
    <app-b220-steps></app-b220-steps>

    <!-- タイトル -->
    <div class="title">
      <h1>
        <label *ngIf="!confirmationFlag">ユーザーの登録</label>
        <label *ngIf="confirmationFlag">登録内容確認</label>
      </h1>
    </div>

    <!-- ユーザー登録(B221) -->
    <div *ngIf="!confirmationFlag">
      <!-- 入力フォーム -->
      <form [formGroup]="b221InputForm">
        <!-- ユー情報 -->
        <div class="user-information">
          <!-- 備考 -->
          <div class="note">
            <label>
              以下の項目に必要事項を記載後、「確認画面へ進む」ボタンをクリックしてください。<br />
              <label class="warning">【必須】の項目は入力必須項目です。必ずご記載ください。
              </label>
              <br />
              運営事務局の承認後に一般公開となります。項目毎の公開、非公開の制御は以下の凡例をご参照ください。<br />
            </label>
            <!-- 公開 -->
            <p-tag value="公開" styleClass="public-tag"></p-tag>
            …一般公開(ウェブサイト上で公開します)<br />
            <!-- 非公開 -->
            <p-tag value="非公開" styleClass="private-tag"></p-tag>
            …公開しません
          </div>

          <!-- ユーザー内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 部局名 -->
              <tr>
                <td class="item-input-name">部局名</td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                    formControlName="department_name" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="b221InputForm.get('department_name')">
                  </app-validator-message>
                </td>
              </tr>

              <!-- 課室名 -->
              <tr>
                <td class="item-input-name">課室名</td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                    formControlName="division_name" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="b221InputForm.get('division_name')">
                  </app-validator-message>
                </td>
              </tr>

              <!-- 役職 -->
              <tr>
                <td class="item-input-name">役職</td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                    formControlName="jobposition_name" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="b221InputForm.get('jobposition_name')">
                  </app-validator-message>
                </td>
              </tr>

              <!-- 氏名 -->
              <tr>
                <td class="item-input-name">
                  氏名
                  <span class="required">【必須】</span>
                  <span class="warning-number">（全角）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="full_name" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="b221InputForm.get('full_name')">
                  </app-validator-message>
                </td>
              </tr>

              <!-- 電話番号 -->
              <tr>
                <td class="item-input-name">
                  電話番号
                  <span class="required">【必須】</span>
                  <span class="warning-number">（半角数字、ハイフン不要）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="tel" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="b221InputForm.get('tel')">
                  </app-validator-message>
                </td>
              </tr>

              <!-- eメールアドレス -->
              <tr>
                <td class="item-input-name">
                  eメールアドレス
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    <label>
                      正しくメールアドレスをご入力してください。誤入力の場合、運営事務局からのメールが受信できません。
                    </label>
                  </div>
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="email" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="b221InputForm.get('email')">
                  </app-validator-message>
                </td>
              </tr>

              <!-- eメールアドレス確認 -->
              <tr>
                <td class="item-input-name">
                  eメールアドレス確認
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    <label>
                      正しくメールアドレスをご入力してください。誤入力の場合、運営事務局からのメールが受信できません。
                    </label>
                  </div>
                  <input type="text" pInputText (input)="checkConfirmationEmail(true)"
                    class="information-Form-inputtext-wMax" formControlName="email_confirmation" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="b221InputForm.get('email_confirmation')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- メルマガ停止設定 -->
              <tr>
                <td class="item-input-name">
                  メルマガ停止設定
                </td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div *ngFor="let dicData of getDicList(123)">
                    <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" formControlName="mailmagazine_flg">
                    </p-checkbox>
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="b221InputForm.get('mailmagazine_flg')">
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </form>

      <!-- ヴァリデーションチェックメッセージエリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="!b221InputForm.valid">
        <label class="warning platform-warning-text">
          未入力の項目、またはエラーがあります。
        </label>
      </div>
      <!-- 余白エリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="b221InputForm.valid">
        <label class="warning platform-warning-text">
          &nbsp;
        </label>
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button pButton type="button" label="確認画面へ進む" class="button-default-size button1" (click)="moveB222()"
          [disabled]="!b221InputForm.valid"></button>
      </div>
    </div>

    <!------------------------------------------------------------------------->

    <!-- ユーザー登録確認(B222) -->
    <div *ngIf="confirmationFlag">
      <!-- ユーザー情報 -->
      <div class="task-information">
        <!-- 備考 -->
        <div class="note">
          下記内容でよろしければ、「登録・更新する」ボタンを押してください。
        </div>

        <!-- ユーザー内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- 部局名 -->
            <tr>
              <td class="item-input-name">部局名</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ b221InputForm.value.department_name }}
              </td>
            </tr>

            <!-- 課室名 -->
            <tr>
              <td class="item-input-name">課室名</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ b221InputForm.value.division_name }}
              </td>
            </tr>

            <!-- 役職名 -->
            <tr>
              <td class="item-input-name">役職名</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ b221InputForm.value.jobposition_name }}
              </td>
            </tr>

            <!-- 氏名 -->
            <tr>
              <td class="item-input-name">
                氏名
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ b221InputForm.value.full_name }}
              </td>
            </tr>

            <!-- 電話番号 -->
            <tr>
              <td class="item-input-name">
                電話番号
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ b221InputForm.value.tel }}
              </td>
            </tr>

            <!-- eメールアドレス -->
            <tr>
              <td class="item-input-name">
                eメールアドレス
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                <label *ngIf="'new' == inputType">
                  {{ b221InputForm.value.email }}
                </label>
                <label *ngIf="'edit' == inputType">
                  {{ editDisplayEmail }}
                </label>
              </td>
            </tr>

            <!-- eメールアドレス確認 -->
            <tr>
              <td class="item-input-name">
                eメールアドレス確認
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                <label *ngIf="'new' == inputType">
                  {{ b221InputForm.value.email_confirmation }}
                </label>
                <label *ngIf="'edit' == inputType">
                  {{ editDisplayEmail }}
                </label>
              </td>
            </tr>

            <!-- メルマガ停止設定 -->
            <tr>
              <td class="item-input-name">メルマガ停止設定</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                <div *ngFor="
                    let dicName of getDicNameList(
                      123,
                      b221InputForm.value.mailmagazine_flg
                    )
                  ">
                  {{ dicName.sp_name }}
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <!-- 余白エリア -->
      <div class="p-d-flex p-jc-center error-area">
        <label class="warning platform-warning-text">
          &nbsp;
        </label>
      </div>

      <!-- ボタンエリア -->
      <div class="button-area">
        <div class="p-d-flex p-jc-center button-middle-area">
          <button pButton type="button" label="登録・更新する" class="button-default-size button1"
            (click)="moveB223()"></button>
          <button pButton type="button" label="修正する" class="button-default-size button2" (click)="moveB221()"></button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>